var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33308 7.66667L7.66642 9L10.6664 6M8.33308 13.3333C11.4627 13.3333 13.9997 10.7963 13.9997 7.66667C13.9997 4.53705 11.4627 2 8.33308 2C5.20347 2 2.66642 4.53705 2.66642 7.66667C2.66642 8.3 2.77031 8.90906 2.962 9.47774C3.03413 9.69175 3.0702 9.79875 3.0767 9.88095C3.08313 9.96213 3.07827 10.019 3.05818 10.098C3.03785 10.1779 2.99295 10.261 2.90314 10.4272L1.81271 12.4456C1.65717 12.7335 1.5794 12.8774 1.5968 12.9885C1.61196 13.0853 1.66891 13.1705 1.75253 13.2215C1.84853 13.2801 2.01128 13.2632 2.33678 13.2296L5.75079 12.8767C5.85418 12.866 5.90587 12.8606 5.95299 12.8624C5.99933 12.8642 6.03205 12.8686 6.07724 12.879C6.12319 12.8896 6.18096 12.9118 6.29652 12.9564C6.92855 13.1999 7.61523 13.3333 8.33308 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionProject);
export default __webpack_public_path__ + "static/media/action-project.e003513ac35b49f415af7025b1c92378.svg";
export { ForwardRef as ReactComponent };